module.exports = __webpack_public_path__ + "static/media/plus.f9b8cc76.svg";